const initialState = {
	translation: undefined,
	location: undefined,
	config: undefined,
};

export default function location(state = initialState, action: any) {
	switch (action.type) {
		case "APP_TRANSLATION": {
			return {
				...state,
				translation: action.data,
			};
		}
		case "APP_LOCATION": {
			return {
				...state,
				location: action.data as {
					country_code: string;
					currency: {
						name: string;
						symbol: string;
						hasSEPA: boolean;
						conversion: number;
						price: {
							annually: {
								min: number;
								max: number;
								default: number;
								gift: number;
								jump: number;
								inputOptions?: number[];
							};
							monthly: {
								min: number;
								max: number;
								default: number;
								gift: number;
								jump: number;
								inputOptions?: number[];
							};
							one: {
								min: number;
								max: number;
								default: number;
								jump: number;
								inputOptions?: number[];
							};
						};
					};
					language: string;
				},
			};
		}
		case "SET_CONFIG": {
			return {
				...state,
				config: action.data,
			};
		}
		default:
			return state;
	}
}
